// 配置路由相关的信息
import VueRouter from 'vue-router'
import Vue from 'vue'
import Layout from '@/layout'
Vue.use(VueRouter)

const routes = [
    {
        path: '',
        name: 'index',
        redirect: '/',
        component: Layout,
        children: [
            {
                path: '/',
                name: 'index',
                component: () => import('@/views/index')
            },
            {
                path: '/proxyhttp',
                name: 'proxyhttp',
                component: () => import('@/views/proxyhttp')
            },
            {
                path: '/proxysmall',
                name: 'proxysmall',
                component: () => import('@/views/proxysmall')
            },
            {
                path: '/proxylong',
                name: 'proxylong',
                component: () => import('@/views/proxylong')
            },
            {
                path: '/proxyip',
                name: 'proxyip',
                component: () => import('@/views/proxyip')
            },
            {
                path: '/bzs',
                name: 'bzs',
                component: () => import('@/views/bzs')
            },
            {
                path: '/smallcity',
                name: 'smallcity',
                component: () => import('@/views/citycode')
            },
            {
                path: '/longcity',
                name: 'longcity',
                component: () => import('@/views/citycode')
            },
        ]
    }
]
const router = new VueRouter({
    routes,
    mode: 'history'
})

export default router

